module.exports = __webpack_public_path__ + "img/22.ab283ab0.png";